/* TODO
 - image and text visibility when items next to each other. delay is multiplied by screen size.
   should be as fast as normally but with delay.
*/

import ReloadableComponentPrototype from 'ReloadableComponentPrototype';
import $ from 'jquery';

export default class ImageAndText extends ReloadableComponentPrototype {
  build() {
    if (this.data.showOnScroll) {
      this.elementData = {
        'cms-image-and-text__content': { element: this.node.find('.cms-image-and-text__content'), alreadyShown: false, timeoutId: null },
        'cms-image-and-text__image': { element: this.node.find('.cms-image-and-text__image'), alreadyShown: false, timeoutId: null },
        'cms-image-and-text__icon': { element: this.node.find('.cms-image-and-text__icon'), alreadyShown: false, timeoutId: null },
      };

      this.addViewHandlers();
      this.handleViewEvents(); // For initial page load
    }
  }

  handleViewEvents() {
    this.handleElementViewEvents('cms-image-and-text__content');
    this.handleElementViewEvents('cms-image-and-text__image');
    this.handleElementViewEvents('cms-image-and-text__icon');
  }

  show(elementSelector) {
    const currentElementData = this.elementData[elementSelector];
    currentElementData.element.addClass(`${elementSelector}--visible`);

    if (currentElementData.timeoutId) {
      clearTimeout(currentElementData.timeoutId);
    }

    currentElementData.alreadyShown = true;
  }

  addViewHandlers() {
    $(window).on('scroll resize', () => {
      this.handleViewEvents();
    });
  }

  handleElementViewEvents(elementSelector) {
    const currentElementData = this.elementData[elementSelector];
    const element = currentElementData.element;
    const elementExists = element.length > 0;

    if (elementExists) {
      if (!currentElementData.alreadyShown) {
        const isSomewhatVisible = this.isInViewport(element[0]);
        if (isSomewhatVisible) {
          const delayDependingOnHorizontalPosition = element[0].getBoundingClientRect().left / (window.innerWidth || document.documentElement.clientWidth) * 250;
          this.showAfterMilliseconds(elementSelector, delayDependingOnHorizontalPosition, true);
        }

        const isVisibleAtAll = this.isInViewport(element[0], 0.01);
        if (isVisibleAtAll) {
          const delayDependingOnHorizontalPosition = 500 + element[0].getBoundingClientRect().left / (window.innerWidth || document.documentElement.clientWidth) * 2000;
          this.showAfterMilliseconds(elementSelector, delayDependingOnHorizontalPosition);
        }
      }
    }
  }

  showAfterMilliseconds(elementSelector, milliseconds, overrideCurrentTimeout = false) {
    const currentElementData = this.elementData[elementSelector];

    if (!currentElementData.timeoutId || overrideCurrentTimeout) {
      currentElementData.timeoutId = setTimeout(() => {
        this.show(elementSelector);
      }, milliseconds);
    }
  }

  isInViewport(htmlElement, percentVisibleOfElementHeight = 0.7) {
    const rectangle = htmlElement.getBoundingClientRect();
    const navigationHeight = this.getNavigationHeight();

    const forceShowAfterPixelsVisible = 300;
    const hasToBeVisiblePercent = Math.min(percentVisibleOfElementHeight, forceShowAfterPixelsVisible / rectangle.height); // 0-1;

    const visible =
      rectangle.bottom > navigationHeight + rectangle.height * hasToBeVisiblePercent &&
      rectangle.right > rectangle.width * hasToBeVisiblePercent &&
      rectangle.top < (window.innerHeight || document.documentElement.clientHeight) - rectangle.height * hasToBeVisiblePercent &&
      rectangle.left < (window.innerWidth || document.documentElement.clientWidth) - rectangle.width * hasToBeVisiblePercent;

    return visible;
  }

  getNavigationHeight() {
    const navigationNode = $('nav.navigation.nav');

    if (navigationNode.length) {
      return navigationNode.height();
    }

    return 0;
  }
}
